import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=f90994c0"
import script from "./chart.vue?vue&type=script&lang=ts"
export * from "./chart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports